import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class ProtectedGridService extends Service {
	constructor(injector: Injector) {
		super("ProtectedGrid", injector);
	}

	// API
	canExport(grid: string) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/CanExport/${grid}`);
	}
}